import type { TMessages } from '@/types/TMessages'

export const messages = {
  defaultTitle: 'Преимущества продукта',
  defaultButtonText: 'Подать заявку',
} satisfies TMessages
